<script>
export default {
  props: {
    classText: { type: String, default: '' },
  },

  computed: {
    classForText: function () {
      let classResult = ''
      let splitClass = this.classText.split(' ')
      if (
        !splitClass.find(function (val) {
          return val.substring(0, 3) === 'fs-'
        })
      ) {
        classResult += ' fs-14'
      }
      if (
        !splitClass.find(function (val) {
          return val.substring(0, 3) === 'fw-'
        })
      ) {
        classResult += ' fw-700'
      }
      if (
        !splitClass.find(function (val) {
          return val.substring(0, 3) === 'mt-'
        })
      ) {
        classResult += ' mt-1'
      }
      if (this.classText && this.classText.length > 0) {
        classResult += ' ' + this.classText
      }

      return classResult.trim()
    },
  },
}
</script>
<template>
  <div class="media align-items-center">
    <span class="avatar avatar-l bg-success mr-3">
      <i class="ti-check fw-700 fs-20 align-sub"></i>
    </span>
    <div class="media-body">
      <p :class="classForText">
        <slot></slot>
      </p>
    </div>
  </div>
</template>
